var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tripRight" },
    [
      _c("div", [
        _c(
          "div",
          { staticClass: "stockDiv" },
          [
            _c("hotel-stock", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkIndex == 0,
                  expression: "checkIndex==0",
                },
              ],
              ref: "hotel",
              attrs: {
                stockTypeObj: _vm.stockTypes[0],
                checkState: _vm.stockTypes[_vm.checkIndex].state,
              },
            }),
            _c("site-stock", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkIndex == 1,
                  expression: "checkIndex==1",
                },
              ],
              ref: "site",
              attrs: {
                stockTypeObj: _vm.stockTypes[1],
                checkState: _vm.stockTypes[_vm.checkIndex].state,
              },
            }),
            _c("spot-stock", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkIndex == 2,
                  expression: "checkIndex==2",
                },
              ],
              ref: "spot",
              attrs: {
                stockTypeObj: _vm.stockTypes[2],
                checkState: _vm.stockTypes[_vm.checkIndex].state,
              },
            }),
            _c("traffic-stock", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkIndex == 3,
                  expression: "checkIndex==3",
                },
              ],
              ref: "traffic",
              attrs: {
                stockTypeObj: _vm.stockTypes[3],
                checkState: _vm.stockTypes[_vm.checkIndex].state,
              },
            }),
            _c("big-traffic", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkIndex == 4,
                  expression: "checkIndex==4",
                },
              ],
            }),
            _c("meal-stock", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkIndex == 5,
                  expression: "checkIndex==5",
                },
              ],
              ref: "meal",
              attrs: {
                stockTypeObj: _vm.stockTypes[5],
                checkState: _vm.stockTypes[_vm.checkIndex].state,
              },
            }),
            _c("guide-stock", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkIndex == 6,
                  expression: "checkIndex==6",
                },
              ],
              ref: "guide",
              attrs: {
                stockTypeObj: _vm.stockTypes[6],
                checkState: _vm.stockTypes[_vm.checkIndex].state,
              },
            }),
            _c("visa-stock", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkIndex == 7,
                  expression: "checkIndex==7",
                },
              ],
              ref: "visa",
              attrs: {
                stockTypeObj: _vm.stockTypes[7],
                checkState: _vm.stockTypes[_vm.checkIndex].state,
              },
            }),
            _c("affair-stock", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkIndex == 8,
                  expression: "checkIndex==8",
                },
              ],
              ref: "affairs",
              attrs: {
                stockTypeObj: _vm.stockTypes[8],
                checkState: _vm.stockTypes[_vm.checkIndex].state,
              },
            }),
            _c("experience-stock", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkIndex == 9,
                  expression: "checkIndex==9",
                },
              ],
              ref: "experience",
              attrs: {
                stockTypeObj: _vm.stockTypes[9],
                checkState: _vm.stockTypes[_vm.checkIndex].state,
              },
            }),
            _c("business-stock", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkIndex == 10,
                  expression: "checkIndex==10",
                },
              ],
              ref: "business",
              attrs: {
                stockTypeObj: _vm.stockTypes[10],
                checkState: _vm.stockTypes[_vm.checkIndex].state,
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "typeDiv" }, [
          _c("div", { staticClass: "typeDivD" }, [
            _c(
              "div",
              _vm._l(_vm.stockTypes, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    class: index == _vm.checkIndex ? "chenckClass" : "",
                    on: {
                      click: function ($event) {
                        return _vm.changeType(index)
                      },
                    },
                  },
                  [_vm._v(_vm._s(item.typeName))]
                )
              }),
              0
            ),
            _c("div", [
              _vm._m(0),
              _c("div", { on: { click: _vm.addPlanProductInquiry } }, [
                _c("p", [_vm._v("项目")]),
                _c("p", [_vm._v("询价")]),
              ]),
              _c("div", { on: { click: _vm.addFastBudget } }, [
                _c("p", [_vm._v("快速")]),
                _c("p", [_vm._v("添加")]),
              ]),
              _vm._m(1),
              _vm._m(2),
            ]),
          ]),
        ]),
      ]),
      _c("plan-product-inquiry-dialog", { ref: "planProductInquiry" }),
      _c("add-fast-budget", { ref: "addFastBudget" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("p", [_vm._v("整团")]), _c("p", [_vm._v("询价")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("p", [_vm._v("智能")]), _c("p", [_vm._v("推荐")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("p", [_vm._v("只看")]), _c("p", [_vm._v("喜欢")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }